import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { actionTypes } from "redux-router5";

export interface PageLoadError {
	status: number;
	routePath: string;
}

export interface PageStatusState {
	loadError: PageLoadError | null;
}

const initialState: PageStatusState = {
	loadError: null,
};

export const pageStatusSlice = createSlice({
	name: "pageStatus",
	initialState,
	reducers: {
		setPageLoadError: (state, action: PayloadAction<PageLoadError>) => {
			state.loadError = action.payload;
		},
		clearPageLoadError: (state) => {
			state.loadError = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(actionTypes.TRANSITION_SUCCESS, (state) => {
			state.loadError = null;
		});
	},
});

export const pageStatusActions = pageStatusSlice.actions;
export default pageStatusSlice.reducer;
